export default {
    name: 'IDropdownDivider'
};
